/* eslint-disable no-unused-vars,prefer-arrow-callback,indent,no-trailing-spaces,prefer-template,no-underscore-dangle,padded-blocks,arrow-body-style,spaced-comment,dot-notation,object-curly-spacing */

import jsonPatchMaker from 'json-patch-gen';

const MerchantVasFactory = (NewBackendService, StorageService, $q, $http, $rootScope, endPoints, StoreService) => {
  'ngInject';

  //UTILS
  const getCookie = (cname) => {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  const __makeJsonPatch__ = (oldObject, newObject) => {
    let jsonPatch = [];
    for (var property in newObject) {
      if (
        oldObject.hasOwnProperty(property)
        &&
        !angular.equals(oldObject[property], newObject[property])
      ) {
        // replace
        jsonPatch.push(
          {
            op: 'replace',
            path: '/' + property,
            value: newObject[property]
          }
        );
      }
      else if (!oldObject.hasOwnProperty(property)) {
        // add
        jsonPatch.push(
          {
            op: 'add',
            path: '/' + property,
            value: newObject[property]
          }
        );
      }
    }
    return jsonPatch;
  };

  /*const getConfigWithAccessToken = () => {
    const config = { headers: {} };
    config.headers = {};
    config.headers['Authorization'] = 'Bearer ' +  StorageService.getLocalStorage('access_token');
    return config;
  };

  const hget = (path) => {
    const config = getConfigWithAccessToken();
    return $http.get(path, config);
  };

  const hpost = (path, body) => {
    const config = getConfigWithAccessToken();
    return $http.post(path, body, config);
  };

  const hpatch = (path, body) => {
    const config = getConfigWithAccessToken();
    return $http.patch(path, body, config);
  };

  const hdelete = (path) => {
    const config = getConfigWithAccessToken();
    return $http.delete(path, config);
  };*/

  //UTILS

  const __getGenericVas__ = (businessId, shopId, vasId) => $q(
    (resolve, reject) => {
      return NewBackendService.invokeWebApiGet(`${endPoints.ecommerceUrl}/businesses/${businessId}/${shopId}/vasses/${vasId}`).then(resolve, reject);
      //return NewBackendService.invokeWebApiGet(`${endPoints.ecommerceUrl}/businesses/${businessId}/vasses/${vasId}`).then(resolve, reject);
    }
  );

  const that = this;

  const baseUrl = '';

  const VAS_TYPES = {
    'ORDER-AND-PAY': 1,
    'ORDER-AND-PICK': 5,
    'ORDER-AND-DELIVERY': 3,
    'ORDER-AT-TABLE': 4,
    'BILL-AT-TABLE': 0,
    'INVOICES': 6,
    'OUTBOUND-MESSAGES': 2,
    'PAY-WITH-ALIPAY': 50,
    'PROJECT-WITH-ALIPAY': 51,
    'MOBILE-PAY-WITH-ALIPAY': 52,
    'CORPORATE-CASH': 7,
    'OFFICE-DELIVERY': 8,
    'ONLINE-PAY-WITH-CONNECT':63,
    'PAY-WITH-PAYPAL': 40,
    1: 'ORDER-AND-PAY',
    5: 'ORDER-AND-PICK',
    3: 'ORDER-AND-DELIVERY',
    4: 'ORDER-AT-TABLE',
    0: 'BILL-AT-TABLE',
    6: 'INVOICES',
    2: 'OUTBOUND-MESSAGES',
    50: 'PAY-WITH-ALIPAY',
    51: 'PROJECT-WITH-ALIPAY',
    52: 'MOBILE-PAY-WITH-ALIPAY',
    7: 'CORPORATE-CASH',
    8: 'OFFICE-DELIVERY',
    63: 'ONLINE-PAY-WITH-CONNECT',
    40: 'PAY-WITH-PAYPAL'
  };

  const service = {

    getVasesTypes: () => {
      return VAS_TYPES;
    },

    /*enableVas: (walletId, vasId) => $q(
      (resolve, reject) => {
        return hpost('/ApiProxy/merchants/' + walletId + '/vasses/' + vasId, {}).then(
          (ok) => {
            $rootScope.$broadcast('ACTIVATED-' + VAS_TYPES[vasId], { success: true, returned: ok });
            resolve(ok);
          }, (error) => {
            $rootScope.$broadcast('ACTIVATED-' + VAS_TYPES[vasId], { success: false, returned: error });
            reject(error);
          });
      }),

    disableVas: (walletId, vasId) => $q(
      (resolve, reject) => {
        return hdelete('/ApiProxy/merchants/' + walletId + '/vasses/' + vasId).then(
          (ok) => {
            $rootScope.$broadcast('DEACTIVATED-' + VAS_TYPES[vasId], { success: true, returned: ok });
            resolve(ok);
          }, (error) => {
            $rootScope.$broadcast('DEACTIVATED-' + VAS_TYPES[vasId], { success: false, returned: error });
            reject(error);
          });
      }
    ),*/

    enableVasForMe: (vasTypeId) => $q(
      (resolve, reject) => {
        var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'))
        var storeId = StoreService.getSelectedStore() ? StoreService.getSelectedStore().id :  StoreService.getSavedStoreList()[0].id
        return NewBackendService.invokeWebApiPost(`${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/${storeId}/vas-types/${vasTypeId}`, {}).then(
          (ok) => {
            $rootScope.$broadcast('ACTIVATED-' + VAS_TYPES[vasTypeId], { success: true, returned: ok });
            resolve(ok);
          }, (error) => {
            $rootScope.$broadcast('ACTIVATED-' + VAS_TYPES[vasTypeId], { success: false, returned: error });
            reject(error);
          });
      }),

    disableVasForMe: (vasTypeId) => $q(
      (resolve, reject) => {
        var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'))
        return NewBackendService.invokeWebApiDelete(`${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/${StoreService.getSelectedStore().id}/vas-types/${vasTypeId}`).then(
        //return NewBackendService.invokeWebApiDelete(`${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/vas-types/${vasTypeId}`).then(
          (ok) => {
            $rootScope.$broadcast('DEACTIVATED-' + VAS_TYPES[vasTypeId], { success: true, returned: ok });
            resolve(ok);
          }, (error) => {
            $rootScope.$broadcast('DEACTIVATED-' + VAS_TYPES[vasTypeId], { success: false, returned: error });
            reject(error);
          });
      }
    ),


    getGenericVas: (walletId, vasId) => $q(
      (resolve, reject) => {
        return __getGenericVas__(walletId, vasId).then(resolve, reject);
      }
    ),


    configureVas: (newVasConfiguration, vasId) => $q((resolve, reject) => {
        var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'))
        __getGenericVas__(merchantProfile.business.id, StoreService.getSelectedStore().id, vasId).then(
          (ok) => {
            const oldVasConfiguration = ok.data.configuration;
            const changes = __makeJsonPatch__(oldVasConfiguration, newVasConfiguration);// jsonPatchMaker(oldVasConfiguration, newVas.configuration);
            NewBackendService.invokeWebApiPatch(`${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/${StoreService.getSelectedStore().id}/vasses/${vasId}`, changes).then(resolve, reject);
            //NewBackendService.invokeWebApiPatch(`${endPoints.ecommerceUrl}/businesses/${merchantProfile.business.id}/vasses/${vasId}`, changes).then(resolve, reject);
          },
          (error) => {
            reject(error);
          }
        );
      }
    ),
    getOrderAndPay: (walletId) => $q(
      (resolve, reject) => {
        return that.getGenericVas(walletId, VAS_TYPES['ORDER-AND-PAY']).then(resolve, reject);
      }
    ),

    getOrderAndPick: (walletId) => $q(
      (resolve, reject) => {
        return that.getGenericVas(walletId, VAS_TYPES['ORDER-AND-PICK']).then(resolve, reject);
      }
    ),

    getOrderAndDelivery: (walletId) => $q(
      (resolve, reject) => {
        return that.getGenericVas(walletId, VAS_TYPES['ORDER-AND-DELIVERY']).then(resolve, reject);
      }
    ),

    getOrderAtTable: (walletId) => $q(
      (resolve, reject) => {
        return that.getGenericVas(walletId, VAS_TYPES['ORDER-AT-TABLE']).then(resolve, reject);
      }
    ),

    getBillAtTable: (walletId) => $q(
      (resolve, reject) => {
        return that.getGenericVas(walletId, VAS_TYPES['BILL-AT-TABLE']).then(resolve, reject);
      }
    ),

    getOfficeDelivery: (walletId) => $q(
      (resolve, reject) => {
          return that.getGenericVas(walletId, VAS_TYPES['OFFICE-DELIVERY']).then(resolve, reject);
      }
    ),

    getOutboundMessages: (walletId) => $q(
      (resolve, reject) => {
        return that.getGenericVas(walletId, VAS_TYPES['OUTBOUND-MESSAGES']).then(resolve, reject);
      }
    ),

    getInvoices: (walletId) => $q(
      (resolve, reject) => {
        return that.getGenericVas(walletId, VAS_TYPES['INVOICES']).then(resolve, reject);
      }
    ),

    getPayWithAlipay: (walletId) => $q(
      (resolve, reject) => {
          return that.getGenericVas(walletId, VAS_TYPES['PAY-WITH-ALIPAY']).then(resolve, reject);
      }
    ),

    getProjectWithAlipay: (walletId) => $q(
      (resolve, reject) => {
          return that.getGenericVas(walletId, VAS_TYPES['PROJECT-WITH-ALIPAY']).then(resolve, reject);
      }
    ),

    getMobilePayWithAlipay: (walletId) => $q(
      (resolve, reject) => {
          return that.getGenericVas(walletId, VAS_TYPES['MOBILE-PAY-WITH-ALIPAY']).then(resolve, reject);
      }
    ),

    getPayWithPaypal: (walletId) => $q(
      (resolve, reject) => {
          return that.getGenericVas(walletId, VAS_TYPES['PAY-WITH-PAYPAL']).then(resolve, reject);
      }
    ),

    getPaypalRegistrationInfo: () => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiGet(`${endPoints.businessUrl}/paypal/businesses/me`).then(resolve, reject);
      }
    ),

    getPaypalRegistrationInfoByAdmin: (businessId) => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiGet(`${endPoints.businessUrl}/paypal/businesses/search?businessId=${businessId}`).then(resolve, reject);
      }
    ),

    startRegistration: (returnUrl, businessId, isSuperAdmin) => $q(
      (resolve, reject) => {
        var url = `${endPoints.businessUrl}/paypal/businesses/registration/start`
        if(isSuperAdmin){
          url = url + `?businessId=${businessId}`
        }
        return NewBackendService.invokeWebApiPost(url, {returnUrl: returnUrl}).then(resolve, reject);
      }
    ),


    getVasByType: (vasTypeId, businessId) => $q(
      (resolve, reject) => {
        var storeId = StoreService.getSelectedStore() ? StoreService.getSelectedStore().id :  StoreService.getSavedStoreList()[0].id
        return NewBackendService.invokeWebApiGet(`${endPoints.ecommerceUrl}/businesses/${businessId}/${storeId}/vas-types/${vasTypeId}`).then(resolve, reject);
      }
    ),

    getPartners: () => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiGet(`${endPoints.businessUrl}/alipay/partners`).then(resolve, reject);
      }
    ),

    getPartnersAlipayOnline: () => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiGet(`${endPoints.businessUrl}/alipay-connect/partners`).then(resolve, reject);
      }
    ),

    getVasesForCurrent: (businessId, storeId) => $q(
      (resolve, reject) => {
        storeId = StoreService.getSelectedStore() ? StoreService.getSelectedStore().id :  StoreService.getSavedStoreList()[0].id
        return NewBackendService.invokeWebApiGet(`${endPoints.ecommerceUrl}/businesses/${businessId}/${storeId}/vasses`).then(
        //return NewBackendService.invokeWebApiGet(`${endPoints.ecommerceUrl}/businesses/${businessId}/vasses`).then(
          (ok) => {
            $rootScope.$broadcast('GOT-VASSES', { success: true, returned: ok });
            resolve(ok);
          }, (error) => {
            $rootScope.$broadcast('GOT-VASSES', { success: false, returned: error });
            reject(error);
          });
      }
    ),

  };
  return service;
};

export default MerchantVasFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/merchant.vas.factory.js
 **/